import { render, staticRenderFns } from "./P2PBanners.vue?vue&type=template&id=3916b2a8&"
import script from "./P2PBanners.vue?vue&type=script&lang=js&"
export * from "./P2PBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports